import BaseService from "../base.service";
import { getResponseQuery } from "../../helpers/_functions";

class EvaluationNotation extends BaseService {
    constructor() {
        super("evaluation-notations");
    }

    updateEvaluationNotation = (evaluationNotation) =>
        getResponseQuery(super.updateById(evaluationNotation));
}

export default new EvaluationNotation();